import React, { Component } from 'react';
import AdminFilteredContentList from './Admin_FilteredContentList';
import { itemContentIssues } from './adminContentValidation';

const itemIsVisible = item => (item.visible ?? item.Visible) !== false;

class ItemList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItemType: "",
            selectedVisibility: "",
        };
    }


    handleFilterChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const {
            enemies,
            filter,
            items,
            onSelectItem,
            onNewItem,
            itemTypes,
            regions,
        } = this.props;
        const filteredItems = items.filter(item => (
            (
                this.state.selectedItemType === ''
                || (item.typeId ?? item.TypeId) === this.state.selectedItemType
            ) && (
                this.state.selectedVisibility === ''
                || this.state.selectedVisibility === (itemIsVisible(item) ? 'visible' : 'hidden')
            )
        ));

        return (
            <div className='admin_list'>
                <button onClick={onNewItem}>Create New Item</button>
                <label>
                    Item type
                    <select
                        name="selectedItemType"
                        value={this.state.selectedItemType}
                        onChange={this.handleFilterChange}
                    >
                        <option key={"all"} value="">All</option>
                        {itemTypes.map((obj, index) =>
                            <option key={index} value={obj.id}>{obj.name}</option>
                        )}
                    </select>
                </label>
                <label>
                    Visibility
                    <select
                        name="selectedVisibility"
                        value={this.state.selectedVisibility}
                        onChange={this.handleFilterChange}
                    >
                        <option value="">Both</option>
                        <option value="visible">Visible</option>
                        <option value="hidden">Hidden</option>
                    </select>
                </label>
                <AdminFilteredContentList
                    context={{ enemies, regions }}
                    filter={filter}
                    getKey={(item, index) => item.id || item.Id || index}
                    kind="item"
                    records={filteredItems}
                    renderRecord={item => {
                        const issues = itemContentIssues(item, itemTypes);
                        const warning = issues.map(issue => issue.message).join(' ');
                        return (
                            <button
                                className="listElement admin-item-list__entry"
                                onClick={() => onSelectItem(item)}
                                type="button"
                            >
                                <span className="admin-item-list__name">
                                    {item.name ?? item.Name}
                                </span>
                                {warning ? (
                                    <span
                                        aria-label={`Warning: ${warning}`}
                                        className="admin-content-warning"
                                        role="img"
                                        title={warning}
                                    >
                                        !
                                    </span>
                                ) : null}
                                <span
                                    aria-label={itemIsVisible(item) ? 'Visible item' : 'Hidden item'}
                                    className={`admin-item-list__status ${itemIsVisible(item)
                                        ? 'is-visible'
                                        : 'is-hidden'}`}
                                    role="img"
                                    title={itemIsVisible(item) ? 'Visible' : 'Hidden'}
                                >
                                    {itemIsVisible(item) ? '●' : '○'}
                                </span>
                            </button>
                        );
                    }}
                />


            </div>
        );
    }
}

export default ItemList;
